// extracted by mini-css-extract-plugin
module.exports = {"filesContainer":"PosDisputesFiles_filesContainer__2RdtG","filesListContainer":"PosDisputesFiles_filesListContainer__1GbCj","filesButton":"PosDisputesFiles_filesButton__3EhiD"};